import React from 'react';
// Constants
import {
  CompanyName,
  KeywordsPages,
} from '../../utils/Constants';
// Data
import {
  linksPageAdditionalMeta,
  linksPageStructuredData,
} from '../../utils/data/MetaData';
// Components
import Navbar from '../../components/nav/Navbar';
import { HelmetItem } from '../../components/utils/HelmetItem';
import LinksPageMainContainer from '../../components/links/LinksPageMainContainer';
import FooterComponent from '../../components/footer/FooterComponent';

function LinksPage() {
  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='External Links & Pay Sites'
        desc={`Explore the exclusive world of ${CompanyName}. Access my premium content, tribute options, and private platforms. Indulge in the experience that awaits.`}
        keywords={KeywordsPages}
        additionalMeta={linksPageAdditionalMeta}
        structuredData={linksPageStructuredData}
      />

      {/* Page */}
      <div className='grid relative min-h-screen font-poppins text-colour2 dark:text-colour1'>
        {/* Main */}
        <div className='grid min-h-screen'>
          {/* Navigation */}
          <Navbar />

          {/* Header */}
          <header className='grid w-full px-6 sm:px-8 md:px-12 lg:container lg:mx-auto py-10'>
            <section className='text-center'>
              <h1 className='font-StencilW01 text-[2.5rem] xs:text-5xl md:text-6xl lg:text-8xl xl:text-9xl text-colour5 font-medium tracking-widest uppercase'>
                Spoil & Treat Me
              </h1>
              <h2 className='text-lg font-StencilW01 uppercase'>
                Follow me on my social media platforms!
              </h2>
            </section>
          </header>

          {/* Main page content */}
          <LinksPageMainContainer />
        </div>

        <FooterComponent />
      </div>
    </>
  );
}

export default LinksPage;
